<template>
  <div>
    <div class="innerItem">
      <p class="innerTitle">
        {{locale.admin_serviceinfo}}
        <!-- <span class="sysMessage">모든 상품 정보 보기</span> -->
      </p>
      <div class="plans">
        <div class="plan"
          v-for="(plan, index) in serviceList"
          :key="index"
          :class="{active: plan.name === sitePlan}">
            <div class="sitePlan">
              <span class="icoSitePlan" :data-plan="plan.name"></span>
              {{plan.name.toUpperCase()}}
            </div>
            <!-- <div class="priceInfo mb15">
              <p>
                <span class="price">{{returnPayment(plan.payment).price}}</span>
                <span v-if="!!returnPayment(plan.payment).term" class="term"> / {{returnPayment(plan.payment).term}}</span>
              </p>
              <p v-if="!!returnPayment(plan.payment).per" class="cf">{{returnPayment(plan.payment).per}}</p>
            </div> -->
            <div>
              <ul class="services">
                <li><span class="label toCapitalize">{{locale.page}}: </span>{{returnLimit(plan.pageLimit)}}</li>
                <li><span class="label toCapitalize">{{locale.coupon}}: </span>{{returnLimit(plan.couponLimit)}}</li>
                <li><span class="label toUppercase">{{locale.tv_channel_guide}}: </span><i class="ox" :data-ox="returnOx(plan.channelguide)">{{returnOx(plan.channelguide)}}</i></li>
                <li><span class="label toCapitalize">{{locale.analytics}}: </span>{{returnAnalytics(plan.analytics)}}</li>
              </ul>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SERVICE from '@/common/service'
import regExp from '@/common/regExp'

export default {
  name: 'ServiceInfo',
  props: [
    'locale'
  ],
  computed: {
    ...mapGetters({
      authInfo: 'authentication/getAuthInfo',
      setting: 'setting/getData'
    }),
    sitePlan () {
      return this.authInfo.sitePlan
    },
    serviceList () {
      return SERVICE.sitePlan
    },
    service () {
      return SERVICE.sitePlan.find(x => x.name === this.sitePlan)
    }
  },
  methods: {
    returnLimit (num) {
      return num === null ? this.locale.unlimited : num
    },
    returnPayment (obj) {
      // return obj === null ? this.locale.free : regExp.comma(obj.price)
      const message = {
        price: this.locale.free.toUpperCase()
      }
      const currencyInfo = this.setting.currency.info
      const cEntity = function (currency) {
        return currencyInfo.find(x => x.c === currency).e
      }
      if (obj !== null) {
        message.price = `${cEntity(obj.currency)}${regExp.comma(obj.price)}`
        message.term = this.locale[obj.term]
        message.per = this.locale.perroom
      }
      return message
    },
    returnOx (boolean) {
      return boolean ? 'O' : 'X'
    },
    returnAnalytics (analytics) {
      return analytics === 0 ? this.locale.service_analytics_basic : this.locale.service_analytics_advanced
    }
  }
}
</script>

<style lang="scss" scoped>
.sitePlan {
  display: inline-block;
  position: relative;
  margin-bottom: 0.5em;
  padding-left: 32px;
  vertical-align: top;
  font-size: 2em;
  font-weight: 700;
  .icoSitePlan {
    position: absolute;
    top: 50%;
    left: 0;
    width: 24px;
    height: 24px;
    margin-top: -12px;
  }
}
.services {
  display: inline-block;
  vertical-align: top;
  text-align: left;
  li {
    color: $color-grey;
    .label {
      color: $color-dark;
      &:before {
        content: "· ";
      }
    }
    .ox {
      color: $color-blue;
      font-weight: bold;
      font-family: 'arial';
      &[data-ox="x"] {
        color: $color-red;
      }
    }
  }
}
.plans {
  display: flex;
  border: 1px solid $color-lgrey2;
}
.plan {
  flex: 1;
  position: relative;
  padding: 60px 30px 120px;
  text-align: center;
  &.active {
    z-index: 1;
    box-shadow: 0 0 0 1px $color-primary;
    .priceInfo .price {
      color: $color-primary;
    }
  }
  & + .plan {
    border-left: 1px solid $color-lgrey2;
  }
}
.priceInfo {
  color: $color-grey;
  .price {
    font-size: 1.4em;
    font-weight: 700;
  }
}
</style>
